import { DateTimePicker } from "@mui/x-date-pickers";
import { Controller } from "react-hook-form";

import type { FieldComponent } from "../types";

const DateTimePickerComponent: FieldComponent<never> = ({ field, methods }) => {
  const {
    formState: { errors },
  } = methods;
  const error = errors[field.name];

  return (
    <Controller
      name={field.name}
      control={methods.control}
      defaultValue={field.defaultValue || null}
      render={({ field: controllerField }) => (
        <DateTimePicker
          {...controllerField}
          label={field.label}
          disabled={field.disabled}
          slotProps={{
            textField: {
              fullWidth: true,
              error: Boolean(error),
              helperText: error?.message as string,
            },
          }}
        />
      )}
    />
  );
};

export default DateTimePickerComponent;
